import { createAction, props } from '@ngrx/store';
import { JobRecommendationCategoriesActions } from 'src/app/accountmanagers/details/flyouts/recommendations-flyout/models/job-recommendation-categories-actions.model';

export const loadJobRecommendations = createAction(
    '[Job Fulfillment Recommendations] Load Recommendations',
    props<{ jobId: number }>()
);
export const loadJobRecommendationsSuccess = createAction(
    '[Job Fulfillment Recommendations] Load Recommendations Successfully',
    props<{
        recommendations: JobRecommendationCategoriesActions[];
        numTodos: number;
        numCompleted: number;
        numDismissed: number;
    }>()
);

export const loadJobRecommendationsFailure = createAction(
    '[Job Fulfillment Recommendations] Load Recommendations Failure',
    props<{ error: unknown }>()
);

export const updateRecommendation = createAction(
    '[Job Fulfillment Recommendations] Update Recommendation',
    props<{ recommendation: JobRecommendationCategoriesActions }>()
);

export const updateRecommendationSuccess = createAction(
    '[Job Fulfillment Recommendations] Update Recommendation Successfully',
    props<{ recommendation: JobRecommendationCategoriesActions }>()
);

export const updateRecommendationFailure = createAction(
    '[Job Fulfillment Recommendations] Update Recommendation Failure',
    props<{ error: unknown }>()
);
